export default function filterSamples(
  sample_list,
  filter,
  schedule_sample_list,
  sample_payload
) {
  const { client, rfid, turnaround, submission, sample_set } = filter;
  const checkContain = (defaultString, content) => {
    return (
      defaultString.toLowerCase().includes(content) ||
      defaultString.toLowerCase().includes(content)
    );
  };
  return sample_list
    .filter(({ submission }) => {
      if (client) {
        if (
          submission &&
          submission.project &&
          submission.project.customer.full_name
        ) {
          return checkContain(submission.project.customer.full_name, client);
        } else {
          return false;
        }
      } else {
        return true;
      }
    })
    .filter(({ receiving_id }) => {
      if (rfid) {
        return receiving_id && checkContain(receiving_id, rfid);
      }
      return true;
    })
    .filter(({ submission }) => {
      if (turnaround) {
        if (submission && submission.turnaround) {
          return checkContain(submission.turnaround.name, turnaround);
        } else {
          return false;
        }
      } else {
        return true;
      }
    })
    .filter(sample => {
      if (submission) {
        return checkContain(sample.getSubmission().publicNumber(), submission);
      } else {
        return true;
      }
    })
    .filter(({ id }) => {
      if (sample_set) {
        const checkSample = ({
          sample_id,
          instrument_instance_id,
          schedulable_task_id
        }) => {
          return (
            sample_id === id &&
            instrument_instance_id === sample_payload.instrument_instance_id &&
            schedulable_task_id === sample_payload.schedulable_task_id
          );
        };
        switch (sample_set) {
          case "on_instrument":
            return !!schedule_sample_list.find(schedule_sample =>
              checkSample(schedule_sample)
            );
          case "not_on_instrument":
            return !schedule_sample_list.find(schedule_sample =>
              checkSample(schedule_sample)
            );
          case "not_scheduled":
            return !schedule_sample_list.find(
              schedule_sample => schedule_sample.sample_id === id
            );
          default:
            return true;
        }
      } else {
        return true;
      }
    })
    .sort((a, b) => {
      if (Number(a.pid) > Number(b.pid)) {
        return 1;
      }
      if (Number(b.pid) > Number(a.pid)) {
        return -1;
      }
      return 0;
    });
}
